<template>
  <div class="sticky-actions">
    <naj-button
      class="incomplete-button"
      @click="showNotCompleteReasons"
    >
      <v-icon>mdi-information</v-icon>
      {{ local.lawsuitRequest.incompleteReasons.title }}
      <v-icon>mdi-chevron-left</v-icon>
    </naj-button>

    <v-expand-x-transition>
      <naj-box
        v-show="isExpanded"
        :title="`الإجراءات `"
        :disable-collapsing="true"
        no-bottom-margin
        class="expand-card"
      >
        <div class="text-subtitle-2">
          {{ local.common.dearApplicant }}:
        </div>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title
              v-for="(item, index) in request.reasons"
              :key="index"
            >
              {{ index + 1 }}. {{ item }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <div class="naj-modal-actions">
          <naj-button
            outlined
            @click="close"
          >
            {{ local.common.close }}
          </naj-button>
        </div>
      </naj-box>
    </v-expand-x-transition>
  </div>
</template>

<script>
import { requestStatus } from '@/helpers/enum';
import najBox from '@/components/shared/naj-box.vue';

export default {
  name: 'IncompleteReasons',
  components: { najBox },
  props: {
    request: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      isExpanded: false,
      requestStatus,
    };
  },
  computed: {},
  watch: {},
  methods: {
    showNotCompleteReasons() {
      this.isExpanded = !this.isExpanded;
    },
    close() {
      this.isExpanded = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/partials/_vars.scss';

.sticky-actions {
  position: fixed;
  left: 6px;
  top: 50%;
  z-index: 50;
  .v-button-wrapper.incomplete-button {
    transform: rotate(270deg);
    position: relative;
    right: 96px;

    .mdi-information {
      color: yellow;
    }

    .mdi-chevron-left {
      color: white;
      transform: rotate(90deg);
    }
  }
  .expand-card {
    position: relative;
    float: left;
    bottom: 92px;
    width: 500px;
    height: 218px;

    .v-list-item {
      display: block !important;
      overflow-y: auto;
      max-height: 127px;

      .v-list-item__title {
        white-space: normal;
      }
    }

    .naj-modal-actions {
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}
</style>
